import { apiClient } from './api';

function unwrapData<T>(res: { success: boolean; data?: T; message?: string; error?: string }, fallbackMsg: string): T {
  if (!res.success || res.data === undefined) {
    throw new Error(res.message || res.error || fallbackMsg);
  }
  return res.data;
}

export type BlogPostRow = {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  image: string;
  author: string;
  tags: string[];
  categoryId: string;
  categoryName?: string;
  isPublished: boolean;
  publishedAt?: string;
};

export type BlogCategoryOption = {
  id: string;
  name: string;
  slug: string;
};

export const blogService = {
  async list(): Promise<Record<string, unknown>[]> {
    const res = await apiClient.get<Record<string, unknown>[]>('/admin/blog');
    return unwrapData(res, 'خطا در دریافت مقالات');
  },
  async categories(): Promise<BlogCategoryOption[]> {
    const res = await apiClient.get<BlogCategoryOption[]>('/admin/blog/categories');
    return unwrapData(res, 'خطا در دریافت دسته‌های بلاگ');
  },
  async create(data: Record<string, unknown>): Promise<Record<string, unknown>> {
    const res = await apiClient.post<Record<string, unknown>>('/admin/blog', data);
    return unwrapData(res, 'ایجاد مقاله ناموفق بود');
  },
  async update(id: string, data: Record<string, unknown>): Promise<Record<string, unknown>> {
    const res = await apiClient.put<Record<string, unknown>>(`/admin/blog/${id}`, data);
    return unwrapData(res, 'ویرایش مقاله ناموفق بود');
  },
  async remove(id: string): Promise<void> {
    const res = await apiClient.delete(`/admin/blog/${id}`);
    if (!res.success) throw new Error(res.message || 'حذف مقاله ناموفق بود');
  },
};
